export default __webpack_public_path__ + "static/src/companys/eif/assets/images/logo/logo_light.svg";